export default {
    register_queue_state: [{
        value: "1",
        text: "已收车"
    }, {
        value: "2",
        text: "已查验"
    }, {
        value: "3",
        text: "未办结"
    }, {
        value: "4",
        text: "已办结"
    }, {
        value: "5",
        text: "已领车"
    }, {
        value: "6",
        text: "已拆解"
    }, {
        value: "7",
        text: "已销售"
    },
    ],
    yes_no_state: [{
        value: 0,
        text: "否"
    }, {

        value: 1,
        text: "是"
    }
    ],
    IsUsing: [{
        value: 0,
        text: "不启用"
    }, {

        value: 1,
        text: "启用"
    }
    ],
    WareHouseStatus: [{
        value: 1,
        text: "正常"
    }, {

        value: 2,
        text: "已满"
    }
    ],
    IsMissParts: [{
        value: 1,
        text: "是"
    }, {

        value: 2,
        text: "否"
    }
    ],

    /// <summary>
    /// 车辆类型
    /// </summary>
    VehicleType: "VehicleType",
    /// <summary>
    /// 动力类型
    /// </summary>
    VehiclePowerType: "VehiclePowerType",
    /// <summary>
    /// 车牌颜色
    /// </summary>
    LicensePlateColor: "LicensePlateColor",
    /// <summary>
    /// 号牌种类
    /// </summary>
    LicensePlateType: "LicensePlateType",
    /// <summary>
    /// 车身颜色
    /// </summary>
    CarColor: "CarColor",

    /// <summary>
    /// 使用性质
    /// </summary>
    UsageType: "UsageType",
    /// <summary>
    /// 发动机排量
    /// </summary>
    EngineDisplacement: "Displacement",

    /// <summary>
    /// 是或否
    /// </summary>
    YesOrNo: "YesOrNo",
}